import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';


export default function CircularIndeterminate() {
  return <CircularProgress />;
}